module.exports = __webpack_public_path__ + "static/media/bat.d3a72db4.svg";